import { render } from "./dept.html?vue&type=template&id=eaf935ba&scoped=true&ts=true"
import script from "./dept.ts?vue&type=script&lang=ts"
export * from "./dept.ts?vue&type=script&lang=ts"

import "./dept.scss?vue&type=style&index=0&id=eaf935ba&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf935ba"]])

export default __exports__